import React, { useState } from "react";
import axios from "axios";

const NameChangePopup = ({ request, actionType, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);


  const handleConfirm = async () => {
    try {
      setLoading(true);
      const res=await axios.put(`${process.env.REACT_APP_API_URL}/name-change-request/update-status/${request._id}`, {
        status: actionType,
      });
      console.log("PUT SUCCESS", res.data)
      onSuccess();
    } catch (err) {
      alert("Failed to update status");
      console.error("PUT ERROR",err.message)

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-[400px]">
        <h2 className="text-lg font-semibold mb-4 text-center">
          {actionType === "Approved"
            ? "Approve Name Change Request"
            : "Reject Name Change Request"}
        </h2>
        <p className="text-gray-600 mb-4 text-center">
          User: <span className="font-medium">{request.userId?.nickName}</span>
          <br />
          Requested Name:{" "}
          <span className="font-medium">{request.requestedNickName}</span>
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-300 text-gray-700 hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className={`px-4 py-2 rounded-lg text-white ${
              actionType === "Approved"
                ? "bg-[#c51369]  hover:bg-[#a10f5b]"
                : "bg-red-600 hover:bg-red-700"
            }`}
          >
            {loading ? "Processing..." : actionType}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NameChangePopup;
